import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { usePopup } from '../contexts/PopupContext';

import styled from 'styled-components';
import { FormWrapper, Label, Select, Button, Input } from '../forms/shared_form_styles';
import { NameWrapper, Row, Column, ButtonSection, InfoLabel, InputName, NavButton, Column25 } from '../forms/shared_details_form_styles';
import { faPlus, faPercent, faHandHoldingDollar, faEye, faPen, faPlay, faStop, faTableList, faUser, faListCheck, faFileCirclePlus, faMagnifyingGlass, faBook, faFileCircleCheck, faTrashCan, faCertificate, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Wrapper, Header, H2, IconButton } from './shared_pages_styles';
import { TableSection, H4, Table, Th, Td, Tr, TableIconButton } from '../table_styles';
import AddPaymentRecord from '../forms/AddPaymentRecord';
import { setStudents } from '../actions/studentActions';
import { setAttendanceModified } from '../actions/loadingActions';
// import { deletePayment, setPaymentRecords } from '../actions/paymentRecordActions';
import { updateAttendance, getAttendances } from '../actions/attendanceActions';

import LoadingSpinner from '../components/LoadingSpinner';

export const Attendance = () => {
  // const paymentsArray = useSelector((state) =>
  //   state.paymentRecords ? state.paymentRecords : null
  // );
  const studentsArray = useSelector((state) =>
    state.students ? state.students : null);
  const attendancesArray = useSelector((state) =>
    state.attendances ? state.attendances : null
  );
  const attendanceModified = useSelector((state) => state.loading.attendanceModified);

  const [filteredAttendances, setFilteredAttendances] = useState("");
  const [studentOptions, setStudentOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('All');
  const [selectedSubject, setSelectedSubject] = useState('All');
  const [selectedType, setSelectedType] = useState('All');
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateUntill, setSelectedDateUntill] = useState(null);
  const [editableAttendances, setEditableAttendances] = useState([]);
  const [updatedAttendances, setUpdatedAttendances] = useState([]);
  const [updateButtonDisabled, setUpdateButtonDisabled] = useState(true);
  const [loadingModifications, setLoadingModifications] = useState(null)

  const typesArray = ['Absent', 'Present', 'All'];
  const { openPopup } = usePopup();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (attendanceModified) {
      setLoadingModifications(true);
      dispatch(setStudents());
    }
    const today = new Date();
    const prevMonthFirstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    setSelectedDateFrom(prevMonthFirstDay.toISOString());
    setSelectedDateUntill(today.toISOString());


  }, []);
  useEffect(() => {
    if (!attendanceModified) {
      setLoadingModifications(false);
    }
  }, [attendanceModified]);
  useEffect(() => {
    const stOptions = [...attendancesArray.filter((attendance, index, self) =>
      index === self.findIndex((t) => (
        t.enrollment && t.enrollment.student && t.enrollment.student.name === attendance.enrollment.student.name
      ))
    ).map(attendance => attendance.enrollment.student.name
    ), 'All'];
    setStudentOptions(stOptions);

    const subjOptions = [...attendancesArray.filter((attendance, index, self) =>
      index === self.findIndex((t) => (
        t.enrollment && t.enrollment.subjectInstance && t.enrollment.subjectInstance.subject && t.enrollment.subjectInstance.subject.name === attendance.enrollment.subjectInstance.subject.name
      ))
    ).map(attendance => attendance.enrollment.subjectInstance.subject.name
    ), 'All'];
    setSubjectOptions(subjOptions);
    setEditableAttendances(attendancesArray);
  }, [attendancesArray]);


  useEffect(() => {
    let filteredAttendances = [];
    if (attendancesArray && attendancesArray.length > 0) {
      filteredAttendances = attendancesArray.filter(attendance =>
        (attendance.enrollment.student.name === selectedStudent || selectedStudent === 'All') &&
        (attendance.enrollment.subjectInstance.subject.name === selectedSubject || selectedSubject === 'All') &&
        (attendance.status === selectedType || selectedType === 'All') &&
        ((new Date(attendance.date) <= new Date(selectedDateUntill)) && (new Date(attendance.date) >= new Date(selectedDateFrom)))
      );
      setFilteredAttendances(filteredAttendances);
    }

  }, [attendancesArray, selectedStudent, selectedSubject, selectedType, selectedDateFrom, selectedDateUntill]);

  const handleEditAttendance = (attendance) => {
    // openPopup(<AddattendanceRecord attendance={attendance} />);
  };
  const handleCheckboxChange = (attendanceId) => {
    const att = editableAttendances.find(edat => edat._id == attendanceId);
    const index = updatedAttendances.findIndex((a) => a._id === att._id);
    const updAttendance = { ...att }; // Create a copy of the attendance object
    updAttendance.status = updAttendance.status === 'Present' ? 'Absent' : 'Present'; // Update the status
    if (index === -1) {
      updatedAttendances.push(updAttendance);
    } else {
      updatedAttendances[index] = updAttendance;
    }
    setUpdatedAttendances(updatedAttendances);
    const editableAttendancesCopy = [...editableAttendances];
    const editableIndex = editableAttendancesCopy.findIndex((a) => a._id === att._id);
    editableAttendancesCopy[editableIndex] = { ...att, status: updAttendance.status };
    setEditableAttendances(editableAttendancesCopy);
    setUpdateButtonDisabled(updatedAttendances.length === 0);
  };
  const handleUpdateAttendances = () => {
    for (const attendance of updatedAttendances) {
      dispatch(updateAttendance({ attendanceId: attendance._id, status: attendance.status }));
    }
    setUpdatedAttendances([]);
    setUpdateButtonDisabled(true);
  };
  if (loadingModifications) {
    return <LoadingSpinner />;
  }

  return (
    <Wrapper>
      <Header>
        <H2>Registros de Asistencia</H2>
        {(updatedAttendances.length > 0) && (
          <IconButton onClick={handleUpdateAttendances} disabled={updateButtonDisabled}>Save</IconButton>)}
      </Header>
      <Row>
        <Column25>
          <Label>
            Student:
            <Select
              value={selectedStudent}
              onChange={(e) => { setSelectedStudent(e.target.value) }}
            >
              {studentOptions.map((item, index) => (
                <option key={index} value={item}>{item}</option>
              ))}
            </Select>
          </Label>
        </Column25>
        <Column25>
          <Label>
            Subject:
            <Select
              value={selectedSubject}
              onChange={(e) => { setSelectedSubject(e.target.value) }}
            >
              {subjectOptions.map((item, index) => (
                <option key={index} value={item}>{item}</option>
              ))}
            </Select>
          </Label>
        </Column25>
        <Column25>
          <Label>
            Date from:
            <Input
              type="date"
              name="dateFrom"
              value={selectedDateFrom !== null ? selectedDateFrom.split('T')[0] : ''}
              onChange={(e) => { setSelectedDateFrom(e.target.value) }}
            />
          </Label>

        </Column25>
        <Column25>
          <Label>
            Date until:
            <Input
              type="date"
              name="dateUntill"
              value={selectedDateUntill !== null ? selectedDateUntill.split('T')[0] : ''}
              onChange={(e) => { setSelectedDateUntill(e.target.value) }}
            />
          </Label>
        </Column25>
        <Column25>
          <Label>
            Type:
            <Select
              value={selectedType}
              onChange={(e) => { setSelectedType(e.target.value) }}
            >
              {typesArray.map((item, index) => (
                <option key={index} value={item}>{item}</option>
              ))}
            </Select>
          </Label>
        </Column25>
      </Row>
      <TableSection>
        <Table>
          <thead>
            <Tr>
              <Th>Student</Th>
              <Th>Date </Th>
              <Th>Type </Th>
              <Th>Subject</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {filteredAttendances && filteredAttendances.map((attendance, index) => (
              <Tr key={index}>
                <Td>{attendance.enrollment.student.name}</Td>
                <Td>{attendance.date && attendance.date.split('T')[0]}</Td>
                <Td>{editableAttendances.find(edat => edat._id == attendance._id).status}</Td>
                <Td>{attendance.enrollment.subjectInstance.subject.name}</Td>
                <Td>
                  <IconButton onClick={() => handleCheckboxChange(attendance._id)}>
                    {editableAttendances.find(edat => edat._id == attendance._id).status === 'Present' ?
                      <FontAwesomeIcon icon={faCheckSquare} />
                      :
                      <FontAwesomeIcon icon={faSquare} />
                    }
                  </IconButton>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableSection>
    </Wrapper >
  );
}
export default Attendance;
